module.exports = "/images/vendor/vue2vis/dist/plus.png?4c4bf0a13eae5c7cdb109f91f8563f77";